import { render, staticRenderFns } from "./ElectiveSubjectPopUp.vue?vue&type=template&id=16044965"
import script from "./ElectiveSubjectPopUp.vue?vue&type=script&lang=js"
export * from "./ElectiveSubjectPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports